<template>
    <v-app-bar app color="white" light clipped-left>
      <router-link to="/" tag="span" style="cursor: pointer">
        <img id="prism_logo_secondary" alt="PRISM Logo" width="130px" src="../../public/images/logo-primary-01.svg"/>
      </router-link>
        <v-tabs hide-slider>
          <v-spacer></v-spacer>
          <v-tab id="portal-tab" to="/">Portal</v-tab>
          <v-tab :to="{name: 'ResourcesPage'}">Resources</v-tab>
          <v-tab :to="{name: 'SubmissionsPage'}">Submissions</v-tab>
          <v-tab id="LoginPage" :to="{name: 'LoginPage'}">
            <v-icon small style="margin-right:4px">mdi-account </v-icon> {{ DisplayUserLogInStatus }}
          </v-tab>
  
        </v-tabs>
    </v-app-bar>
  </template>
  <script>
  // import Vue from 'vue';
  export default {
    name: "AppBar",
  data(){
    return {
    }
  },
    methods: {

    },
    computed: {
      DisplayUserLogInStatus(){
        const user_info = localStorage.getItem('user_info');
          const user_info_parsed = JSON.parse(user_info);
        if (user_info_parsed){
          if (user_info_parsed.email != "clue_demo@clue.io"){
            return "Account"
          } else {
            return "Log In"
          }
        } else {
          return "Log In"
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .v-app-bar{
    border-bottom:2px solid #4699FF !important;
    box-shadow: 0.5px 0.5px 15px 0px rgba(220, 220, 220, 0.5) !important;
    z-index:1000;
  }
  
  /* .v-application .background {
      border-color: rgba(0, 0, 0, 0.12) !important;
  } */
  
  </style>
  